module.exports = __webpack_public_path__ + "static/img/nosotros_titulo.439d99a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/nosotros_titulo.jpg
// module id = IG3Y
// module chunks = 0